export default "__VITE_ASSET__PtAL$fwe__"